import { VehicleType } from '../../enums/VehicleType';
import {
  FilterInventoryAction,
  FilterInventoryActionType,
  MinMaxFilter,
} from './InventoryFilterActions';

export type InventoryFilterState = {
  years: number[];
  models: string[];
  trims: string[];
  brands: string[];
  vehicleTypes: VehicleType[];
  ageDays: MinMaxFilter;
  mileage: MinMaxFilter;
  price: MinMaxFilter;
  exteriorColor: string[];
  interiorColor: string[];
  search: string;
};

export const initialInventoryFilterState: InventoryFilterState = {
  years: [],
  models: [],
  trims: [],
  brands: [],
  vehicleTypes: [],
  ageDays: {
    min: -1,
    max: -1,
  },
  mileage: {
    min: -1,
    max: -1,
  },
  price: {
    min: -1,
    max: -1,
  },
  exteriorColor: [],
  interiorColor: [],
  search: '',
};

export const inventoryFilterReducer = (
  state: InventoryFilterState = initialInventoryFilterState,
  action: FilterInventoryAction,
): InventoryFilterState => {
  switch (action.type) {
    case FilterInventoryActionType.SET_YEARS:
      return {
        ...state,
        years: action.payload,
      };
    case FilterInventoryActionType.SET_MODELS:
      return {
        ...state,
        models: action.payload,
      };
    case FilterInventoryActionType.SET_TRIMS:
      return {
        ...state,
        trims: action.payload,
      };
    case FilterInventoryActionType.SET_VEHICLE_TYPES:
      return {
        ...state,
        vehicleTypes: action.payload,
      };
    case FilterInventoryActionType.SET_BRANDS:
      return {
        ...state,
        brands: action.payload,
      };
    case FilterInventoryActionType.SET_DAYS_ON_LOT:
      return {
        ...state,
        ageDays: action.payload,
      };
    case FilterInventoryActionType.SET_MILEAGE:
      return {
        ...state,
        mileage: action.payload,
      };
    case FilterInventoryActionType.SET_PRICE:
      return {
        ...state,
        price: action.payload,
      };
    case FilterInventoryActionType.SET_EXTERIOR_COLOR:
      return {
        ...state,
        exteriorColor: action.payload,
      };
    case FilterInventoryActionType.SET_INTERIOR_COLOR:
      return {
        ...state,
        interiorColor: action.payload,
      };
    case FilterInventoryActionType.SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case FilterInventoryActionType.FILTERS_RESET:
      return {
        ...initialInventoryFilterState,
      };
    default:
      return state;
  }
};
